import type { JSX } from "react";
import { useState } from "react";

import ArrowRight from "@repo/icons/default/ArrowRight";
import InformationCircle from "@repo/icons/default/InformationCircle";
import {
  CpsAlertV2IconArea,
  CpsAlertV2Root,
  CpsAlertV2TextArea,
  CpsAlertV2Title,
} from "corpus";

import { Button } from "@/components/ui/button/button";
import { FileUploadCard } from "@/components/ui/file-upload-card/file-upload-card";
import {
  CardSelectDescription,
  CardSelectTitle,
} from "@/components/ui/select-input/card-select.tsx";

interface ProfessionWithoutCouncilSubStepProps {
  onSubmit: (fileUrl: string | null) => void;
  isLoading?: boolean;
  acceptedDocuments?: string[];
}

const DegreeCertificateFileType = 4;

export const ProfessionWithoutCouncilSubStep = ({
  onSubmit,
  isLoading,
  acceptedDocuments,
}: ProfessionWithoutCouncilSubStepProps): JSX.Element => {
  const [fileId, setFileId] = useState<string | null>(null);

  return (
    <div className="flex flex-col gap-6 h-full justify-between pb-6">
      <div className="flex flex-col gap-4">
        <div>
          <CardSelectTitle>
            Envie um dos documentos aceitos para validar sua formação
          </CardSelectTitle>
          <CardSelectDescription>
            Para especialidades sem conselho regulador, precisamos validar formação ou
            certificação na área.
          </CardSelectDescription>
        </div>

        <FileUploadCard
          codTipoArquivo={DegreeCertificateFileType}
          onUploadFile={setFileId}
          allowPdf
        />

        {acceptedDocuments && acceptedDocuments.length > 0 ? (
          <CpsAlertV2Root type="info" htmlProps={{ className: "items-start" }}>
            <CpsAlertV2IconArea>
              <InformationCircle className="fill-secondary-400" size={24} />
            </CpsAlertV2IconArea>
            <CpsAlertV2TextArea>
              <CpsAlertV2Title type="info">Documentos aceitos</CpsAlertV2Title>
              <ul className="mt-2 flex flex-col gap-4">
                {acceptedDocuments.map((doc) => (
                  <li key={doc} className="flex items-start gap-2">
                    <span
                      className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-secondary-700"
                      aria-hidden="true"
                    />
                    <span className="text-sm text-neutral-700">{doc}</span>
                  </li>
                ))}
              </ul>
            </CpsAlertV2TextArea>
          </CpsAlertV2Root>
        ) : null}
      </div>

      <div className="flex sticky bottom-0 self-end bg-white w-full">
        <Button
          loading={isLoading}
          fullWidth
          onClick={() => onSubmit(fileId)}
          disabled={!fileId}
        >
          <div className="flex flex-row gap-2 items-center">
            Continuar
            <ArrowRight size={24} />
          </div>
        </Button>
      </div>
    </div>
  );
};
